import React from 'react';
import { Vehicle } from 'core/models/vehicle';
import { useChannelLayout } from './useChannelLayout';
import { VehicleMonitor as VehicleMonitorView } from 'components/views/molecules/VehicleMonitor';
import { VehicleStatus } from './VehicleStatus';
import { VideoPlayer } from './VideoPlayer';
import { useMainScreenLayout } from 'services/useCameraLayout';
import { AssignedCamera } from 'core/models/layout';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';
import { useChannelFromTag } from 'services/useChannelFromTag';

export type VehicleMonitorProps = {
    vehicleId: Vehicle.Id;
    projectId: Project.Id;
    environmentId: Environment.Id;
    className?: string;
    viewOnly: boolean;
}

export const VehicleMonitor = (props: VehicleMonitorProps) => {
    const { vehicleId, projectId, environmentId, viewOnly } = props;

    const [displayLayout] = useMainScreenLayout(vehicleId);

    const layout = useChannelLayout(vehicleId, projectId, environmentId);

    function cameraMonitorIfExist(camera: AssignedCamera | undefined, audio = false) {
        const location = camera?.tag;
        const mirror = camera?.mirror ?? false;
        const upsidedown = camera?.upsidedown ?? false;
        const channel = location && layout
            ? layout.cameras.get(location)
            : undefined;
        return channel
            ? <VideoPlayer channel={channel} mirror={mirror} upsidedown={upsidedown} audio={audio} viewOnly={viewOnly} projectId={projectId} environmentId={environmentId} stretch={true} />
            : undefined;
    }

    const microphoneChannel = useChannelFromTag(displayLayout.microphone?.tag, layout);

    return (
        <VehicleMonitorView
            status={<VehicleStatus vehicleId={vehicleId} projectId={projectId} environmentId={environmentId} channel={viewOnly ? undefined : microphoneChannel} />}
            back={cameraMonitorIfExist(displayLayout.top[1])}
            panel={cameraMonitorIfExist(displayLayout.top[2])}
            left={cameraMonitorIfExist(displayLayout.left[0])}
            front={cameraMonitorIfExist(displayLayout.center[0], true)}
            right={cameraMonitorIfExist(displayLayout.right[0])}
        />
    );
};
